/**
 * ARAM Platform - Logistics Mode Store
 * Core Desarrollos S.A.S - Copyright 2024-2026
 *
 * Tracks which logistics mode the admin is viewing.
 * Controls sidebar navigation visibility and page context.
 *
 * Three modes:
 *  - ultima_milla:      Reparto urbano / Last Mile
 *  - freight_forwarder: Comercio exterior / Freight Forwarding
 *  - multimodal:        Todo integrado / Full Platform
 */

import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { VerticalKey } from '@/config/verticals'

interface LogisticsModeState {
  /** Active logistics mode */
  activeMode: VerticalKey
  /** Switch to a different mode */
  setMode: (mode: VerticalKey) => void
}

export const useLogisticsModeStore = create<LogisticsModeState>()(
  persist(
    (set) => ({
      activeMode: 'multimodal',
      setMode: (mode) => set({ activeMode: mode }),
    }),
    { name: 'aram-logistics-mode' }
  )
)
